'use client';

// Force client-side rendering for all routes to avoid Clerk prerendering issues
export default function Template({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}